module.exports = __webpack_public_path__ + "img/电视机背板1.546e6311.jpg";